export default __webpack_public_path__ + "static/media/footer-instagram.9149bfab.svg";